import { LanguageCode } from '../types';

export const LANGUAGES: { code: LanguageCode; label: string }[] = [
  { code: 'KM', label: 'Kurmancî' },
  { code: 'FR', label: 'Français' },
  { code: 'DE', label: 'Deutsch' },
  { code: 'EN', label: 'English' },
  { code: 'TR', label: 'Türkçe' },
];

export const translations: Record<LanguageCode, Record<string, string>> = {
  KM: {
    // Nav & General
    home: 'SEREKE',
    aboutUs: 'KOMELA ME',
    activities: 'ÇALAKÎ',
    news: 'NÛÇE',
    events: 'RÛDAN',
    culture: 'ÇANDA KURDÎ',
    membership: 'ENDAMETÎ',
    donate: 'PIŞTGIRÎ BIDE',
    documents: 'BELGE',
    gallery: 'GALERÎ',
    contact: 'TÊKILÎ',
    liveStream: 'WEŞANA ZINDÎ',
    ads: 'REKLAMLAR',
    adminPanel: 'PANELA RÊVEBERIYÊ',
    memberPanel: 'PANELA ENDAM',
    searchPlaceholder: 'Lêgerîn di malperê de...',
    searchResultTitle: 'Encamên Lêgerînê',
    noResults: 'Tiştek nehat dîtin.',
    quickServices: 'Xizmetên Lezgîn',
    latestNews: 'Nûçeyên Dawî',
    upcomingEvents: 'Rûdanên Nêzîk',
    pastEvents: 'Rûdanên Berê',
    kurdishCulture: 'Çanda Kurdî ya Dewlemend',
    statistics: 'Statîstîkên Me',
    liveNow: 'WEŞANA ZINDÎ',
    joinLive: 'Tevlî Weşanê Bibe',
    readMore: 'Pêşdetir Bixwîne',
    details: 'Hûragahî',
    explore: 'Keşf Bikin',
    joinUs: 'Tevlî Me Bibe',
    donateNow: 'Bexş Bike',
    login: 'Têketin',
    register: 'Tevlî Bibe',
    logout: 'Derketin',
    profile: 'Profila Min',
    myDues: 'Rêjeyên Min',
    myDonations: 'Bexşên Min',
    myEvents: 'Rûdanên Min',
    myDocuments: 'Belgeyên Min',
    messages: 'Peyam & Sohbet',
    notifications: 'Agedarî',
    qrMemberCard: 'Karta Endametiya QR',
    languageSelect: 'Ziman Hilbijêre',
    themeSelect: 'Mijar',
    close: 'Bigire',
    save: 'Toma Bikin',
    cancel: 'Betal Bikin',
    delete: 'Jê Bibe',
    edit: 'Biguherîne',
    add: 'Zêde Bikin',
    active: 'Çalak',
    passive: 'Neçalak',
    filter: 'Fîltre',
    sort: 'Rêz Bikin',
    exportExcel: 'Rapor (Excel)',
    exportPdf: 'Rapor (PDF)',
    print: 'Bapêş Bikin',
    
    // Stats
    totalMembers: 'Tevahiya Endaman',
    totalActivities: 'Çalakiyên Çêbûyî',
    totalEvents: 'Rûdanên Organîzekirî',
    totalDonations: 'Bexşên Civiyayî',

    // Quick services descriptions
    qsActivitiesDesc: 'Projeyên ku nirxê didin civakê',
    qsEventsDesc: 'Civînên çandî û civakî',
    qsMembershipDesc: 'Tevlî civaka me bibin',
    qsLiveDesc: 'Weşanên me yên zindî bişopînin',
    qsDonateDesc: 'Em bi hev re bihêztir in',
    qsDocumentsDesc: 'Rêzikname û raporên darayî',

    // About Section
    aboutBadge: 'Komela Me',
    aboutMainTitle: 'Komela Çandî ya Fransî-Kurdî ya Yvelines',
    aboutSubtitle: 'Rêxistina me ya civakî ji bo parastina mîraseya me ya çandî û veguhastina wê ji nifşên nû re hatiye damezrandin.',
    foundingStory: 'Dîroka Damezrandinê',
    foundingStoryP1: 'Komela me di sala 2010an de ji bo parastina dewlemendiya çandî, bihêzkirina piştevaniya civakî û piştgirîkirina hînbûna zimanê kurdî hate damezrandin.',
    foundingStoryP2: 'Bi cejna Newrozê, kursên ziman, kampa ciwanan û piştgiriya mirovî re em gihîştine hezaran malbatên li Fransayê û Ewropayê.',
    presidentsMessage: 'Peyama Serok',
    presidentsQuote: '"Çand hafizeya gel e. Em bi xwedîderketina li kokên xwe pirdên piştevaniyê ava dikin; ziman, muzîk û hezkirina xwe diyarî tevahiya mirovahiyê dikin."',
    mission: 'Mîsyona Me',
    missionDesc: 'Anîna çand, wêje û hunera kurdî di jîngehên azad de; amadekirina derfetên perwerdeyê ji bo ciwanan.',
    vision: 'Vîzyona Me',
    visionDesc: 'Têketina nava saziyên çandî yên nûjen, zelal û navneteweyî.',
    values: 'Rêgezên Me',
    val1Title: 'Piştevaniya Çandî',
    val1Desc: 'Baweriya civakî ya ku bi hev re hildiberîne û çandê digihîne paşerojê.',
    val2Title: 'Zelalî û Bawerî',
    val2Desc: 'Pargandina vekirî û kontrola serbixwe di raporên darayî de.',
    val3Title: 'Wekhevî û Beşdarî',
    val3Desc: 'Rola çalak a jin, ciwan û zarokan di tevahiya rêveberiyê de.',
    val4Title: 'Mafên Mirov û Aşitî',
    val4Desc: 'Parastina mafên mirovî yên gerdûnî û diyaloga civakî ya aştiyane.',

    // Activities Section
    activitiesBadge: 'Çalakiyên Me',
    activitiesMainTitle: 'Proje û Xebatên Civakî',
    activitiesSubtitle: 'Kursa ziman, alîkariya civakî, atolyeyên jin û ciwanan û hemû projeyên sûdmend.',
    searchActivities: 'Di çalakiyan de lêgerîn...',
    applyActivity: 'Tevlî Çalakiyê Bibe',
    appliedSuccessMsg: 'Serlêdana we bi serkeftî hate wergirtin! Spas dikin.',
    participantCount: 'Beşdar',

    // News Section
    newsBadge: 'Nûçe & Agedarî',
    newsMainTitle: 'Nûçeyên Rojevê û Raxistinên Çapemeniyê',
    newsSubtitle: 'Çalakiyên herî dawî yên komelê, daxuyaniyên fermî û bultena çandî.',
    searchNews: 'Di nûçeyan de lêgerîn...',
    publishedDate: 'Dîroka Weşanê',
    author: 'Nivîskar',

    // Events Section
    eventsBadge: 'Rojjimara Rûdanan',
    eventsMainTitle: 'Buluşmayên Çandî û Konser',
    eventsSubtitle: 'Konser, konferans û şevên çandî ku hemû endam û gelê me vexwendî ne.',
    registerEvent: 'Qeyd Bibe (QR)',
    eventCapacity: 'Kapasîte',

    // Culture Section
    cultureBadge: 'Çanda Kurdî',
    cultureSubtitle: 'Muzîk, Kevneşopî û Hunerên Kurdî Keşf Bikin',
    cultureDesc: 'Dengbêjî, wêje, ziman, kincên gelêrî û xwarinên kevneşopî di atolyeyên komela me de tên yaşandin.',
    interactiveLangGuide: 'Rêberê Zimanê Kurdî û Bilêvkirinê',
    usefulPhrases: 'Peyvên Rojane',

    // Donate Section
    donateBadge: 'Piştgirî Bide',
    donateMainTitle: 'Ji bo Piştevaniya Çandî Bexş Bike',
    donateSubtitle: 'Kursên ziman, bursên xwendekaran û weşanên me bi bexşên we zindî dibin.',
    donateSuccessTitle: 'Ji bo Bexşa We Ji Dil Spas Dikin!',
    donateSuccessDesc: 'Bexşa we bi serkeftî hat wergirtin û makbûza we ji e-postaya we re hat şandin.',
    selectAmount: 'Mîqdarê Hilbijêre',
    customAmount: 'Mîqdarek Din (EUR)',
    campaignSelect: 'Fonê Hilbijêre',
    paymentMethod: 'Rêbaza Peredayînê',
    creditCard: 'Karta Krediyê',
    sepaTransfer: 'Veguhastina Bankê (SEPA)',

    // Documents Section
    documentsBadge: 'Belgeyên Fermî',
    documentsMainTitle: 'Rêzikname, Rapor û Belgeyên Îdarî',
    documentsSubtitle: 'Rêziknameya komelê, bilançoya darayî ya salane û formên serlêdanê.',
    downloadDoc: 'Belgeyê Daxîne',

    // Gallery Section
    galleryBadge: 'Galerî',
    galleryMainTitle: 'Arşîva Wêne û Videoyan',
    gallerySubtitle: 'Dîmenên ji festîval, konferans, kurs û çalakiyên me yên çandî.',
    allMedia: 'Hemû Medya',
    photos: 'Wêne',
    videos: 'Video',

    // Contact Section
    contactBadge: 'Têkilî',
    contactMainTitle: 'Bi Me Re Têkiliyê Danîn',
    contactSubtitle: 'Ji bo pirs, serlêdana endametiyê an pêşniyarên çandî bi me re di peywendiyê de bin.',
    mainAddress: 'Navnîşana Navendî',
    phoneWhatsapp: 'Telefon & WhatsApp',
    startWhatsappChat: 'Sohbeta WhatsApp Dest Pê Bibe',
    emailAddresses: 'Navnîşanên E-Postayê',
    sendMessageTitle: 'Peyam Ji Me Re Bişînin',
    fullNameLabel: 'Nav û Paşnav',
    emailLabel: 'Navnîşana E-Posta',
    subjectLabel: 'Mijar',
    messageLabel: 'Peyama We',
    sendBtn: 'Peyamê Bişîne',
    msgSuccessTitle: 'Peyama We Hat Şandin!',
    msgSuccessDesc: 'Em ê di demeke kurt de ji we re bersivê bidin.',

    // Live Stream Section
    liveBadge: 'CANLI YAYIN',
    liveTitle: 'Semînera Taybet a Hefteya Zimanê Kurdî & Şeva Dengbêjiyê',
    liveSub: 'Weşanên zindî yên komela me li ser YouTube, Facebook û Zoom.',
    chatRoomTitle: 'Oda Sohbetê ya Zindî',
    typeMessage: 'Peyama xwe binivîse...',

    // Member Panel Section
    memberPortal: 'Panela Endametiya Komelê',
    profileDetails: 'Zanyariyên Min',
    personalInfo: 'Zanyariyên Kesane',
    phoneNumber: 'Hejmara Telefonê',
    address: 'Navnîşan',
    city: 'Bajar',
    country: 'Welat',
    saveChanges: 'Guhertinan Toma Bikin',
    duesPayment: 'Peredayîna Rêjeyê',
    duesHistory: 'Dîroka Rêjeyan',
    totalDonationsCount: 'Tevahiya Katkî',
    guestUser: 'Bikarhênerê Mêvan',
    guestSubtitle: 'Tevlî civaka me ya çandî bibin',

    // Navigation & Actions
    goBack: 'Paşve',
    goForward: 'Pêşve',

    // Footer & Legal
    corporate: 'SAZÎBÛN',
    quickAccess: 'Gihîştina Lezgîn',
    footerAboutDesc: 'Rêxistina civaka sivîl ku ji bo parastin, zindîhiştin û veguhastina çand, ziman û kevneşopiyên Kurdî ji bo nifşên pêşerojê dixebite.',
    statuteAndBalance: 'Rêzikname & Bilanço',
    allRightsReserved: 'Hemû maf parastî ne.',
    privacyPolicy: 'Siyaseta Sira Taybet',
    cookiePolicy: 'Tercîhên Çerezan',
    gdprNotice: 'Rênişandana KVKK / GDPR',
    adminLogin: 'Panela Rêveberiyê',
  },

  FR: {
    home: 'ACCUEIL',
    aboutUs: 'NOTRE ASSOCIATION',
    activities: 'NOS ACTIVITÉS',
    news: 'ACTUALITÉS',
    events: 'ÉVÉNEMENTS',
    culture: 'CULTURE KURDE',
    membership: 'ADHÉSION',
    donate: 'FAIRE UN DON',
    documents: 'DOCUMENTS',
    gallery: 'GALERIE',
    contact: 'CONTACT',
    liveStream: 'EN DIRECT',
    ads: 'PUBLICITÉS',
    adminPanel: 'ADMINISTRATION',
    memberPanel: 'ESPACE MEMBRE',
    searchPlaceholder: 'Rechercher sur le site...',
    searchResultTitle: 'Résultats de recherche',
    noResults: 'Aucun résultat trouvé.',
    quickServices: 'Services Rapides',
    latestNews: 'Dernières Actualités',
    upcomingEvents: 'Événements À Venir',
    pastEvents: 'Événements Passés',
    kurdishCulture: 'Riche Culture Kurde',
    statistics: 'Nos Statistiques',
    liveNow: 'EN DIRECT',
    joinLive: 'Rejoindre le Direct',
    readMore: 'En savoir plus',
    details: 'Détails',
    explore: 'Découvrir',
    joinUs: 'Nous Rejoindre',
    donateNow: 'Faire un Don',
    login: 'Connexion',
    register: 'S\'inscrire',
    logout: 'Déconnexion',
    profile: 'Mon Profil',
    myDues: 'Mes Cotisations',
    myDonations: 'Mes Dons',
    myEvents: 'Mes Événements',
    myDocuments: 'Mes Documents',
    messages: 'Messages & Chat',
    notifications: 'Notifications',
    qrMemberCard: 'Carte Membre QR',
    languageSelect: 'Langue',
    themeSelect: 'Thème',
    close: 'Fermer',
    save: 'Enregistrer',
    cancel: 'Annuler',
    delete: 'Supprimer',
    edit: 'Modifier',
    add: 'Ajouter',
    active: 'Actif',
    passive: 'Inactif',
    filter: 'Filtrer',
    sort: 'Trier',
    exportExcel: 'Exporter Excel',
    exportPdf: 'Exporter PDF',
    print: 'Imprimer',
    
    totalMembers: 'Membres Totaux',
    totalActivities: 'Activités Réalisées',
    totalEvents: 'Événements Organisés',
    totalDonations: 'Dons Collectés',

    qsActivitiesDesc: 'Des projets à forte valeur sociale',
    qsEventsDesc: 'Rencontres culturelles et sociales',
    qsMembershipDesc: 'Rejoignez notre communauté',
    qsLiveDesc: 'Suivez nos diffusions en direct',
    qsDonateDesc: 'Ensemble, nous sommes plus forts',
    qsDocumentsDesc: 'Statuts et rapports financiers',

    aboutBadge: 'Notre Association',
    aboutMainTitle: 'Association Culturelle Franco-Kurde des Yvelines',
    aboutSubtitle: 'Notre organisation œuvre pour préserver notre patrimoine culturel et le transmettre aux nouvelles générations.',
    foundingStory: 'Notre Histoire',
    foundingStoryP1: 'Fondée en 2010 pour préserver notre richesse culturelle, renforcer la solidarité sociale et soutenir l\'apprentissage de la langue kurde.',
    foundingStoryP2: 'À travers les festivals de Newroz, les cours de langue, les camps de jeunesse et nos actions humanitaires, nous touchons des milliers de familles.',
    presidentsMessage: 'Mot du Président',
    presidentsQuote: '"La culture est la mémoire d\'un peuple. En préservant nos racines, nous bâtissons des ponts de solidarité et partageons notre langue et notre art."',
    mission: 'Notre Mission',
    missionDesc: 'Faire vivre la culture, la littérature et les arts kurdes dans des espaces de liberté et former la jeunesse.',
    vision: 'Notre Vision',
    visionDesc: 'Devenir une institution culturelle numérique et physique moderne, transparente et reconnue au niveau international.',
    values: 'Nos Valeurs',
    val1Title: 'Solidarité Culturelle',
    val1Desc: 'Une conscience communautaire qui produit ensemble et transmet la culture aux générations futures.',
    val2Title: 'Transparence & Confiance',
    val2Desc: 'Audits indépendants et rapports financiers ouverts dans toutes nos activités.',
    val3Title: 'Égalité & Participation',
    val3Desc: 'Rôle actif des femmes, des jeunes et des enfants dans toute notre gouvernance.',
    val4Title: 'Droits Humains & Paix',
    val4Desc: 'Défense des valeurs universelles des droits humains et dialogue social paisible.',

    activitiesBadge: 'Nos Activités',
    activitiesMainTitle: 'Projets Sociaux et Ateliers',
    activitiesSubtitle: 'Cours de langue, aide sociale, ateliers femmes et jeunesse à forte utilité publique.',
    searchActivities: 'Rechercher une activité...',
    applyActivity: 'Participer à l\'activité',
    appliedSuccessMsg: 'Votre inscription a été enregistrée avec succès ! Merci.',
    participantCount: 'Participants',

    newsBadge: 'Actualités & Communiqués',
    newsMainTitle: 'Dernières Actualités et Déclarations',
    newsSubtitle: 'Les récentes actions de notre association, annonces culturelles et déclarations officielles.',
    searchNews: 'Rechercher dans les actualités...',
    publishedDate: 'Date de publication',
    author: 'Auteur',

    eventsBadge: 'Agenda des Événements',
    eventsMainTitle: 'Rencontres Culturelles et Concerts',
    eventsSubtitle: 'Concerts, conférences et soirées culturelles ouverts à tous nos membres et au public.',
    registerEvent: 'S\'inscrire (QR)',
    eventCapacity: 'Capacité',

    cultureBadge: 'Culture Kurde',
    cultureSubtitle: 'Découvrez la Musique, la Langue et les Traditions Kurdes',
    cultureDesc: 'L\'art des Dengbêjs, la littérature, les costumes traditionnels et la gastronomie préservés dans nos ateliers.',
    interactiveLangGuide: 'Guide Interactif de la Langue Kurde',
    usefulPhrases: 'Expressions Utiles',

    donateBadge: 'Faire un Don',
    donateMainTitle: 'Soutenez la Solidarité Culturelle',
    donateSubtitle: 'Nos cours de langue, bourses d\'études et publications vivent grâce à vos dons.',
    donateSuccessTitle: 'Merci Du Fond Du Cœur Pour Votre Don !',
    donateSuccessDesc: 'Votre don a été reçu avec succès et votre reçu vous a été envoyé par e-mail.',
    selectAmount: 'Choisir un Montant',
    customAmount: 'Autre Montant (EUR)',
    campaignSelect: 'Choisir le Fonds',
    paymentMethod: 'Moyen de Paiement',
    creditCard: 'Carte Bancaire',
    sepaTransfer: 'Virement SEPA',

    documentsBadge: 'Documents Officiels',
    documentsMainTitle: 'Statuts, Rapports et Formulaires',
    documentsSubtitle: 'Conformément à notre principe de transparence, consultez nos statuts, bilans et formulaires.',
    downloadDoc: 'Télécharger le Document',

    galleryBadge: 'Galerie',
    galleryMainTitle: 'Archives Photos et Vidéos',
    gallerySubtitle: 'Clichés de nos festivals, conférences, cours et moments de convivialité.',
    allMedia: 'Tous les Médias',
    photos: 'Photos',
    videos: 'Vidéos',

    contactBadge: 'Contact',
    contactMainTitle: 'Contactez-Nous',
    contactSubtitle: 'Pour toute question, demande d\'adhésion ou suggestion culturelle, écrivez-nous.',
    mainAddress: 'Adresse Principale',
    phoneWhatsapp: 'Téléphone & WhatsApp',
    startWhatsappChat: 'Démarrer un Chat WhatsApp',
    emailAddresses: 'Adresses E-Mail',
    sendMessageTitle: 'Envoyez-Nous un Message',
    fullNameLabel: 'Nom et Prénom',
    emailLabel: 'Adresse E-Mail',
    subjectLabel: 'Sujet',
    messageLabel: 'Votre Message',
    sendBtn: 'Envoyer le Message',
    msgSuccessTitle: 'Message Envoyé !',
    msgSuccessDesc: 'Nous vous répondrons dans les plus brefs délais.',

    liveBadge: 'EN DIRECT',
    liveTitle: 'Séminaire Spécial Semaine de la Langue Kurde & Concert Dengbêj',
    liveSub: 'Diffusions en direct de notre association sur YouTube, Facebook et Zoom.',
    chatRoomTitle: 'Espace de Discussion en Direct',
    typeMessage: 'Écrivez votre message...',

    memberPortal: 'Espace Adhérent Association',
    profileDetails: 'Mes Informations',
    personalInfo: 'Informations Personnelles',
    phoneNumber: 'Numéro de Téléphone',
    address: 'Adresse',
    city: 'Ville',
    country: 'Pays',
    saveChanges: 'Enregistrer les Modifications',
    duesPayment: 'Paiement de Cotisation',
    duesHistory: 'Historique des Cotisations',
    totalDonationsCount: 'Contribution Totale',
    guestUser: 'Utilisateur Invité',
    guestSubtitle: 'Rejoignez notre communauté culturelle',

    // Navigation & Actions
    goBack: 'Retour',
    goForward: 'Suivant',

    corporate: 'Institutionnel',
    quickAccess: 'Accès Rapide',
    footerAboutDesc: 'Organisation de la société civile œuvrant pour préserver, faire vivre et transmettre la culture, la langue et les traditions kurdes aux générations futures.',
    statuteAndBalance: 'Statuts & Bilan',
    allRightsReserved: 'Tous droits réservés.',
    privacyPolicy: 'Politique de Confidentialité',
    cookiePolicy: 'Gestion des Cookies',
    gdprNotice: 'Notice RGPD / Protection des Données',
    adminLogin: 'Administration',
  },

  DE: {
    home: 'STARTSEITE',
    aboutUs: 'ÜBER UNS',
    activities: 'AKTIVITÄTEN',
    news: 'NACHRICHTEN',
    events: 'VERANSTALTUNGEN',
    culture: 'KURDISCHE KULTUR',
    membership: 'MITGLIEDSCHAFT',
    donate: 'SPENDEN',
    documents: 'DOKUMENTE',
    gallery: 'GALERIE',
    contact: 'KONTAKT',
    liveStream: 'LIVE-STREAM',
    ads: 'ANZEIGEN',
    adminPanel: 'ADMIN-PANEL',
    memberPanel: 'MITGLIEDERBEREICH',
    searchPlaceholder: 'Suche auf der Website...',
    searchResultTitle: 'Suchergebnisse',
    noResults: 'Keine Ergebnisse gefunden.',
    quickServices: 'Schnellzugriff',
    latestNews: 'Neueste Nachrichten',
    upcomingEvents: 'Kommende Events',
    pastEvents: 'Vergangene Events',
    kurdishCulture: 'Kurdische Kultur',
    statistics: 'Statistiken',
    liveNow: 'JETZT LIVE',
    joinLive: 'Live Zusehen',
    readMore: 'Mehr lesen',
    details: 'Details',
    explore: 'Entdecken',
    joinUs: 'Mitmachen',
    donateNow: 'Jetzt Spenden',
    login: 'Anmelden',
    register: 'Registrieren',
    logout: 'Abmelden',
    profile: 'Mein Profil',
    myDues: 'Beiträge',
    myDonations: 'Meine Spenden',
    myEvents: 'Meine Events',
    myDocuments: 'Meine Dokumente',
    messages: 'Nachrichten & Chat',
    notifications: 'Benachrichtigungen',
    qrMemberCard: 'QR-Mitgliedskarte',
    languageSelect: 'Sprache',
    themeSelect: 'Design',
    close: 'Schließen',
    save: 'Speichern',
    cancel: 'Abbrechen',
    delete: 'Löschen',
    edit: 'Bearbeiten',
    add: 'Hinzufügen',
    active: 'Aktiv',
    passive: 'Inaktiv',
    filter: 'Filtern',
    sort: 'Sortieren',
    exportExcel: 'Excel Export',
    exportPdf: 'PDF Export',
    print: 'Drucken',

    totalMembers: 'Gesamtmitglieder',
    totalActivities: 'Aktivitäten',
    totalEvents: 'Veranstaltungen',
    totalDonations: 'Gesammelte Spenden',

    qsActivitiesDesc: 'Projekte mit gesellschaftlichem Mehrwert',
    qsEventsDesc: 'Kulturelle und soziale Treffen',
    qsMembershipDesc: 'Werde Teil unserer Gemeinschaft',
    qsLiveDesc: 'Folge unseren Live-Übertragungen',
    qsDonateDesc: 'Gemeinsam sind wir stark',
    qsDocumentsDesc: 'Satzung und Finanzberichte',

    aboutBadge: 'Unser Verein',
    aboutMainTitle: 'Kurdischer Kulturverein Yvelines',
    aboutSubtitle: 'Unsere Organisation setzt sich für den Erhalt unseres kulturellen Erbes und die Weitergabe an junge Generationen ein.',
    foundingStory: 'Gründungsgeschichte',
    foundingStoryP1: 'Gegründet 2010 zur Bewahrung unserer kulturellen Vielfalt, Förderung der sozialen Solidarität und Unterstützung des Erlernens der kurdischen Sprache.',
    foundingStoryP2: 'Mit Newroz-Festen, Sprachkursen, Jugendcamps und humanitärer Hilfe erreichen wir Tausende von Familien.',
    presidentsMessage: 'Wort des Vorsitzenden',
    presidentsQuote: '"Kultur ist das Gedächtnis eines Volkes. Indem wir unsere Wurzeln pflegen, bauen wir Brücken der Solidarität."',
    mission: 'Unsere Mission',
    missionDesc: 'Kurdische Kultur, Literatur und Kunst in freien Räumen fördern und der Jugend Bildungschancen bieten.',
    vision: 'Unsere Vision',
    visionDesc: 'Eine moderne, transparente und international anerkannte Kulturinstitution zu sein.',
    values: 'Unsere Werte',
    val1Title: 'Kulturelle Solidarität',
    val1Desc: 'Gemeinsam erschaffen und Kultur für die Zukunft bewahren.',
    val2Title: 'Transparenz & Vertrauen',
    val2Desc: 'Unabhängige Überprüfung und offene Finanzberichte.',
    val3Title: 'Gleichberechtigung & Teilhabe',
    val3Desc: 'Aktive Rolle von Frauen, Jugendlichen und Kindern in der Vereinsarbeit.',
    val4Title: 'Menschenrechte & Frieden',
    val4Desc: 'Einsatz für universelle Menschenrechte und friedlichen gesellschaftlichen Dialog.',

    activitiesBadge: 'Unsere Aktivitäten',
    activitiesMainTitle: 'Soziale Projekte und Workshops',
    activitiesSubtitle: 'Sprachkurse, Sozialhilfe, Frauen- und Jugendworkshops mit hohem gesellschaftlichem Nutzen.',
    searchActivities: 'Aktivität suchen...',
    applyActivity: 'An Aktivität teilnehmen',
    appliedSuccessMsg: 'Ihre Anmeldung war erfolgreich! Vielen Dank.',
    participantCount: 'Teilnehmer',

    newsBadge: 'Nachrichten & Aktuelles',
    newsMainTitle: 'Aktuelle Nachrichten & Pressemitteilungen',
    newsSubtitle: 'Neueste Aktivitäten unseres Vereins, Ankündigungen und Berichte.',
    searchNews: 'Nachrichten durchsuchen...',
    publishedDate: 'Veröffentlichungsdatum',
    author: 'Autor',

    eventsBadge: 'Veranstaltungskalender',
    eventsMainTitle: 'Kulturtreffen und Konzerte',
    eventsSubtitle: 'Konzerte, Konferenzen und Kulturabende für Mitglieder und Interessierte.',
    registerEvent: 'Anmelden (QR)',
    eventCapacity: 'Kapazität',

    cultureBadge: 'Kurdische Kultur',
    cultureSubtitle: 'Entdecken Sie kurdische Musik, Sprache und Traditionen',
    cultureDesc: 'Dengbêj-Kunst, Literatur, Trachten und kulinarische Spezialitäten in unseren Workshops.',
    interactiveLangGuide: 'Interaktiver Sprachführer Kurdisch',
    usefulPhrases: 'Nützliche Redewendungen',

    donateBadge: 'Jetzt Spenden',
    donateMainTitle: 'Kulturelle Solidarität unterstützen',
    donateSubtitle: 'Sprachkurse, Stipendien und Publikationen werden durch Ihre Spenden ermöglicht.',
    donateSuccessTitle: 'Herzlichen Dank für Ihre Spende!',
    donateSuccessDesc: 'Ihre Spende ist eingegangen und die Quittung wurde per E-Mail versandt.',
    selectAmount: 'Betrag auswählen',
    customAmount: 'Anderer Betrag (EUR)',
    campaignSelect: 'Fonds auswählen',
    paymentMethod: 'Zahlungsart',
    creditCard: 'Kreditkarte',
    sepaTransfer: 'SEPA-Überweisung',

    documentsBadge: 'Offizielle Dokumente',
    documentsMainTitle: 'Satzung, Berichte und Anträge',
    documentsSubtitle: 'In Übereinstimmung mit unserer Transparenz können Sie Satzungen und Berichte einsehen.',
    downloadDoc: 'Dokument herunterladen',

    galleryBadge: 'Galerie',
    galleryMainTitle: 'Foto- und Videoarchiv',
    gallerySubtitle: 'Impressionen von Festen, Konferenzen, Kursen und Begegnungen.',
    allMedia: 'Alle Medien',
    photos: 'Fotos',
    videos: 'Videos',

    contactBadge: 'Kontakt',
    contactMainTitle: 'Kontaktieren Sie uns',
    contactSubtitle: 'Bei Fragen, Mitgliedschaftsanträgen oder Anregungen stehen wir Ihnen gerne zur Verfügung.',
    mainAddress: 'Hauptadresse',
    phoneWhatsapp: 'Telefon & WhatsApp',
    startWhatsappChat: 'WhatsApp-Chat starten',
    emailAddresses: 'E-Mail-Adressen',
    sendMessageTitle: 'Schreiben Sie uns eine Nachricht',
    fullNameLabel: 'Vollständiger Name',
    emailLabel: 'E-Mail-Adresse',
    subjectLabel: 'Betreff',
    messageLabel: 'Ihre Nachricht',
    sendBtn: 'Nachricht senden',
    msgSuccessTitle: 'Nachricht gesendet!',
    msgSuccessDesc: 'Wir werden Ihnen so schnell wie möglich antworten.',

    liveBadge: 'LIVE STREAM',
    liveTitle: 'Sonderseminar zur Kurdischen Sprachwoche & Dengbêj-Konzert',
    liveSub: 'Live-Übertragungen unseres Vereins auf YouTube, Facebook und Zoom.',
    chatRoomTitle: 'Live-Chatraum',
    typeMessage: 'Schreiben Sie eine Nachricht...',

    memberPortal: 'Mitgliederbereich Verein',
    profileDetails: 'Meine Daten',
    personalInfo: 'Persönliche Daten',
    phoneNumber: 'Telefonnummer',
    address: 'Adresse',
    city: 'Stadt',
    country: 'Land',
    saveChanges: 'Änderungen speichern',
    duesPayment: 'Mitgliedsbeitrag zahlen',
    duesHistory: 'Beitragsverlauf',
    totalDonationsCount: 'Gesamtbeitrag',
    guestUser: 'Gastbenutzer',
    guestSubtitle: 'Treten Sie unserer Kulturfamilie bei',

    // Navigation & Actions
    goBack: 'Zurück',
    goForward: 'Weiter',

    corporate: 'Vereinigung',
    quickAccess: 'Schnellzugriff',
    footerAboutDesc: 'Zivilgesellschaftliche Organisation zum Schutz, Erhalt und zur Weitergabe der kurdischen Kultur, Sprache und Traditionen an zukünftige Generationen.',
    statuteAndBalance: 'Satzung & Bilanz',
    allRightsReserved: 'Alle Rechte vorbehalten.',
    privacyPolicy: 'Datenschutzerklärung',
    cookiePolicy: 'Cookie-Einstellungen',
    gdprNotice: 'DSGVO-Hinweise',
    adminLogin: 'Administration',
  },

  EN: {
    home: 'HOME',
    aboutUs: 'ABOUT US',
    activities: 'ACTIVITIES',
    news: 'NEWS',
    events: 'EVENTS',
    culture: 'KURDISH CULTURE',
    membership: 'MEMBERSHIP',
    donate: 'DONATE',
    documents: 'DOCUMENTS',
    gallery: 'GALLERY',
    contact: 'CONTACT',
    liveStream: 'LIVE STREAM',
    ads: 'ADVERTISEMENTS',
    adminPanel: 'ADMIN DASHBOARD',
    memberPanel: 'MEMBER PORTAL',
    searchPlaceholder: 'Search platform...',
    searchResultTitle: 'Search Results',
    noResults: 'No records found.',
    quickServices: 'Quick Services',
    latestNews: 'Latest News',
    upcomingEvents: 'Upcoming Events',
    pastEvents: 'Past Events',
    kurdishCulture: 'Rich Kurdish Culture',
    statistics: 'Our Impact',
    liveNow: 'LIVE NOW',
    joinLive: 'Watch Live Stream',
    readMore: 'Read More',
    details: 'View Details',
    explore: 'Explore Now',
    joinUs: 'Join Us',
    donateNow: 'Donate Today',
    login: 'Sign In',
    register: 'Sign Up',
    logout: 'Log Out',
    profile: 'My Profile',
    myDues: 'Membership Dues',
    myDonations: 'My Donations',
    myEvents: 'Registered Events',
    myDocuments: 'My Documents',
    messages: 'Messages & Chat',
    notifications: 'Notifications',
    qrMemberCard: 'Digital QR Pass',
    languageSelect: 'Select Language',
    themeSelect: 'Appearance',
    close: 'Close',
    save: 'Save Changes',
    cancel: 'Cancel',
    delete: 'Delete',
    edit: 'Edit',
    add: 'Add New',
    active: 'Active',
    passive: 'Inactive',
    filter: 'Filter',
    sort: 'Sort',
    exportExcel: 'Excel Report',
    exportPdf: 'PDF Report',
    print: 'Print Document',

    totalMembers: 'Total Members',
    totalActivities: 'Activities Held',
    totalEvents: 'Events Organized',
    totalDonations: 'Donations Raised',

    qsActivitiesDesc: 'Projects creating community impact',
    qsEventsDesc: 'Cultural and social gatherings',
    qsMembershipDesc: 'Join our vibrant community',
    qsLiveDesc: 'Watch our live broadcasts',
    qsDonateDesc: 'Together we are stronger',
    qsDocumentsDesc: 'Bylaws and financial reports',

    aboutBadge: 'Our Association',
    aboutMainTitle: 'Franco-Kurdish Cultural Association of Yvelines',
    aboutSubtitle: 'Our organization works to preserve our cultural heritage and pass it on to future generations.',
    foundingStory: 'Founding Story',
    foundingStoryP1: 'Established in 2010 to protect our rich heritage, strengthen social solidarity, and support Kurdish language education.',
    foundingStoryP2: 'Through Newroz festivals, language classes, youth camps, and humanitarian efforts, we reach thousands of families.',
    presidentsMessage: "President's Message",
    presidentsQuote: '"Culture is the memory of a people. By preserving our roots, we build bridges of solidarity and share our language and art."',
    mission: 'Our Mission',
    missionDesc: 'Promoting Kurdish culture, literature, and art in open environments and providing educational opportunities to youth.',
    vision: 'Our Vision',
    visionDesc: 'To become a modern, transparent, and internationally recognized cultural organization.',
    values: 'Core Values',
    val1Title: 'Cultural Solidarity',
    val1Desc: 'A unified community producing together and passing culture to the future.',
    val2Title: 'Transparency & Trust',
    val2Desc: 'Independent auditing and open financial disclosure in all operations.',
    val3Title: 'Equality & Participation',
    val3Desc: 'Active involvement of women, youth, and children across governance.',
    val4Title: 'Human Rights & Peace',
    val4Desc: 'Advocating universal human rights and peaceful social dialogue.',

    activitiesBadge: 'Our Activities',
    activitiesMainTitle: 'Social Projects and Workshops',
    activitiesSubtitle: 'Language classes, social relief, women and youth workshops delivering social benefit.',
    searchActivities: 'Search activities...',
    applyActivity: 'Join Activity',
    appliedSuccessMsg: 'Your application has been received successfully! Thank you.',
    participantCount: 'Participants',

    newsBadge: 'News & Announcements',
    newsMainTitle: 'Latest News & Press Releases',
    newsSubtitle: 'Recent developments from our association, event announcements, and official press releases.',
    searchNews: 'Search news...',
    publishedDate: 'Publication Date',
    author: 'Author',

    eventsBadge: 'Event Calendar',
    eventsMainTitle: 'Cultural Gatherings and Concerts',
    eventsSubtitle: 'Concerts, conferences, and cultural nights open to members and the public.',
    registerEvent: 'Register (QR Pass)',
    eventCapacity: 'Capacity',

    cultureBadge: 'Kurdish Culture',
    cultureSubtitle: 'Discover Kurdish Music, Language, and Traditions',
    cultureDesc: 'Dengbêj art, literature, traditional attire, and gastronomy preserved through our active workshops.',
    interactiveLangGuide: 'Interactive Kurdish Language Guide',
    usefulPhrases: 'Useful Expressions',

    donateBadge: 'Donate',
    donateMainTitle: 'Support Cultural Solidarity',
    donateSubtitle: 'Our language courses, student scholarships, and publications thrive through your donations.',
    donateSuccessTitle: 'Heartfelt Thanks For Your Contribution!',
    donateSuccessDesc: 'Your donation has been received successfully and your receipt was sent to your email.',
    selectAmount: 'Select Amount',
    customAmount: 'Custom Amount (EUR)',
    campaignSelect: 'Select Cause',
    paymentMethod: 'Payment Method',
    creditCard: 'Credit Card',
    sepaTransfer: 'SEPA Bank Transfer',

    documentsBadge: 'Official Documents',
    documentsMainTitle: 'Bylaws, Reports, and Application Forms',
    documentsSubtitle: 'In line with our transparency principle, access our association bylaws and annual financial statements.',
    downloadDoc: 'Download File',

    galleryBadge: 'Gallery',
    galleryMainTitle: 'Photo & Video Archive',
    gallerySubtitle: 'Moments from our festivals, conferences, language classes, and cultural events.',
    allMedia: 'All Media',
    photos: 'Photos',
    videos: 'Videos',

    contactBadge: 'Contact Us',
    contactMainTitle: 'Get In Touch',
    contactSubtitle: 'Reach out to our team for questions, membership inquiries, or cultural proposals.',
    mainAddress: 'Headquarters Address',
    phoneWhatsapp: 'Phone & WhatsApp',
    startWhatsappChat: 'Start WhatsApp Chat',
    emailAddresses: 'Email Addresses',
    sendMessageTitle: 'Send Us A Message',
    fullNameLabel: 'Full Name',
    emailLabel: 'Email Address',
    subjectLabel: 'Subject',
    messageLabel: 'Your Message',
    sendBtn: 'Send Message',
    msgSuccessTitle: 'Message Sent!',
    msgSuccessDesc: 'We will get back to you as soon as possible.',

    liveBadge: 'LIVE STREAM',
    liveTitle: 'Kurdish Language Week Special Seminar & Dengbêj Performance',
    liveSub: 'Our live broadcast seminars on YouTube, Facebook, and Zoom.',
    chatRoomTitle: 'Live Chat Room',
    typeMessage: 'Type your message...',

    memberPortal: 'Association Member Portal',
    profileDetails: 'My Account Details',
    personalInfo: 'Personal Information',
    phoneNumber: 'Phone Number',
    address: 'Address',
    city: 'City',
    country: 'Country',
    saveChanges: 'Save Changes',
    duesPayment: 'Pay Dues',
    duesHistory: 'Dues History',
    totalDonationsCount: 'Total Contribution',
    guestUser: 'Guest Visitor',
    guestSubtitle: 'Join our cultural community',

    // Navigation & Actions
    goBack: 'Back',
    goForward: 'Next',

    corporate: 'Corporate',
    quickAccess: 'Quick Links',
    footerAboutDesc: 'A civil society organization dedicated to preserving, promoting, and passing down Kurdish culture, language, and traditions to future generations.',
    statuteAndBalance: 'Bylaws & Financials',
    allRightsReserved: 'All rights reserved.',
    privacyPolicy: 'Privacy Policy',
    cookiePolicy: 'Cookie Preferences',
    gdprNotice: 'GDPR / Data Protection Notice',
    adminLogin: 'Admin Portal',
  },

  TR: {
    home: 'ANA SAYFA',
    aboutUs: 'DERNEĞİMİZ',
    activities: 'FAALİYETLERİMİZ',
    news: 'HABERLER',
    events: 'ETKİNLİKLER',
    culture: 'KÜRT KÜLTÜRÜ',
    membership: 'ÜYELİK',
    donate: 'DESTEK OL',
    documents: 'BELGELER',
    gallery: 'GALERİ',
    contact: 'İLETİŞİM',
    liveStream: 'CANLI YAYIN',
    ads: 'REKLAMLAR',
    adminPanel: 'YÖNETİM PANELİ',
    memberPanel: 'ÜYE PANELİ',
    searchPlaceholder: 'Platformda arama yapın...',
    searchResultTitle: 'Arama Sonuçları',
    noResults: 'Hiçbir sonuç bulunamadı.',
    quickServices: 'Hızlı Servis Kutuları',
    latestNews: 'Son Haberler',
    upcomingEvents: 'Yaklaşan Etkinlikler',
    pastEvents: 'Geçmiş Etkinlikler',
    kurdishCulture: 'Zengin Kürt Kültürü',
    statistics: 'Etki ve İstatistiklerimiz',
    liveNow: 'ŞİMDİ CANLI',
    joinLive: 'Canlı Yayına Katıl',
    readMore: 'Devamını Oku',
    details: 'Detayları İncele',
    explore: 'Derneğimizi Keşfet',
    joinUs: 'Bize Katıl',
    donateNow: 'Bağış Yap',
    login: 'Giriş Yap',
    register: 'Üye Ol',
    logout: 'Çıkış Yap',
    profile: 'Profilim',
    myDues: 'Aidatlarım',
    myDonations: 'Bağışlarım',
    myEvents: 'Etkinliklerim',
    myDocuments: 'Belgelerim',
    messages: 'Mesajlar & Sohbet',
    notifications: 'Bildirimler',
    qrMemberCard: 'QR Üye Kartı',
    languageSelect: 'Dil Seçeneği',
    themeSelect: 'Tema',
    close: 'Kapat',
    save: 'Kaydet',
    cancel: 'İptal',
    delete: 'Sil',
    edit: 'Düzenle',
    add: 'Yeni Ekle',
    active: 'Aktif',
    passive: 'Pasif',
    filter: 'Filtrele',
    sort: 'Sırala',
    exportExcel: 'Excel Raporu',
    exportPdf: 'PDF Raporu',
    print: 'Yazdır',

    totalMembers: 'Toplam Üye',
    totalActivities: 'Toplam Faaliyet',
    totalEvents: 'Toplam Etkinlik',
    totalDonations: 'Toplanan Bağış',

    qsActivitiesDesc: 'Topluma değer katan projeler',
    qsEventsDesc: 'Kültürel ve sosyal buluşmalar',
    qsMembershipDesc: 'Topluluğumuza katılın',
    qsLiveDesc: 'Canlı yayınlarımızı takip edin',
    qsDonateDesc: 'Birlikte daha güçlüyüz',
    qsDocumentsDesc: 'Tüzük ve mali raporlar',

    aboutBadge: 'Derneğimiz',
    aboutMainTitle: 'Yvelines Fransız-Kürt Kültür Derneği',
    aboutSubtitle: 'Kültürel mirasımızı korumak, dilimizi ve geleneklerimizi gelecek nesillere aktarmak amacıyla kurulan sivil toplum örgütümüz.',
    foundingStory: 'Kuruluş Hikayesi',
    foundingStoryP1: 'Derneğimiz, kültürel zenginliğimizi korumak, üyelerimiz arasında toplumsal dayanışmayı güçlendirmek ve dil eğitimlerini desteklemek amacıyla 2010 yılında kurulmuştur.',
    foundingStoryP2: 'Avrupa genelinde ve yerel ölçekte gerçekleştirdiğimiz Newroz festivalleri, dil kursları, gençlik kampları ve insani yardım kampanyaları ile binlerce aileye ulaşmış bulunuyoruz.',
    presidentsMessage: 'Başkan Mesajı',
    presidentsQuote: '"Kültür bir halkın hafızasıdır. Bizler, köklerimize sahip çıkarak dayanışma köprüleri kuruyor; dilimizi, müziğimizi ve sevgimizi tüm insanlıkla paylaşıyoruz."',
    mission: 'Misyonumuz',
    missionDesc: 'Kürt kültürünü, edebiyatını ve sanatını özgür ortamlarda yaşatmak; gençlerin yeteneklerini geliştirmeleri için eğitim olanakları sunmak.',
    vision: 'Vizyonumuz',
    visionDesc: 'Uluslararası alanda tanınan, çağdaş, şeffaf ve kapsayıcı bir dijital ve fiziki kültür kurumu haline gelmek.',
    values: 'Değerlerimiz',
    val1Title: 'Kültürel Dayanışma',
    val1Desc: 'Birlikte üreten, paylaşan ve kültürümüzü geleceğe taşıyan bir topluluk bilinci.',
    val2Title: 'Şeffaflık & Güven',
    val2Desc: 'Mali raporlarımız ve tüm faaliyetlerimizde bağımsız denetim ve açık paylaşım.',
    val3Title: 'Eşitlik & Katılımcılık',
    val3Desc: 'Kadınların, gençlerin ve çocukların tüm yönetim ve kültürel süreçlerde etkin rolü.',
    val4Title: 'İnsan Hakları & Barış',
    val4Desc: 'Evrensel insan hakları değerlerini savunma ve barışçıl toplumsal diyalog.',

    activitiesBadge: 'Faaliyetlerimiz',
    activitiesMainTitle: 'Toplumsal Projelerimiz ve Çalışmalarımız',
    activitiesSubtitle: 'Dil kursları, sosyal yardımlar, kadın ve gençlik atölyeleri ile toplumsal fayda sağlayan tüm projelerimiz.',
    searchActivities: 'Faaliyetlerde arama yapın...',
    applyActivity: 'Faaliyete Katıl',
    appliedSuccessMsg: 'Başvurunuz başarıyla alındı! Teşekkür ederiz.',
    participantCount: 'Katılımcı',

    newsBadge: 'Haberler & Duyurular',
    newsMainTitle: 'Güncel Haberler ve Basın Açıklamaları',
    newsSubtitle: 'Derneğimizin en son faaliyetleri, kültürel etkinlik duyuruları ve resmi kamuoyu açıklamaları.',
    searchNews: 'Haberlerde ara...',
    publishedDate: 'Yayın Tarihi',
    author: 'Yazar',

    eventsBadge: 'Etkinlik Takvimi',
    eventsMainTitle: 'Kültür Sanat Buluşmaları ve Konserler',
    eventsSubtitle: 'Tüm üyelerimizin ve halkımızın davetli olduğu konserler, konferanslar ve kültürel geceler.',
    registerEvent: 'Detay ve Kayıt Ol (QR)',
    eventCapacity: 'Kapasite',

    cultureBadge: 'Çanda Kurdî',
    cultureSubtitle: 'Kürt Kültürü, Müziği ve Geleneğini Keşfedin',
    cultureDesc: 'Binlerce yıllık köklü geçmişe sahip Dengbêjlik geleneği, edebiyatı, dili ve el sanatları derneğimizin atölyeleriyle yaşatılmaktadır.',
    interactiveLangGuide: 'Kürtçe Sesli Telaffuz ve Dil Rehberi',
    usefulPhrases: 'Günlük Deyimler',

    donateBadge: 'Destek Ol',
    donateMainTitle: 'Kültürel Dayanışmaya Bağış Yapın',
    donateSubtitle: 'Derneğimizin dil kursları, öğrenci bursları ve kültürel yayınları sizin bağışlarınızla yaşam bulmaktadır.',
    donateSuccessTitle: 'Bağışınız İçin Yürekten Teşekkür Ederiz!',
    donateSuccessDesc: 'Bağışınız başarıyla alınmış olup makbuzunuz e-posta adresinize gönderilmiştir.',
    selectAmount: 'Miktar Seçin',
    customAmount: 'Diğer Miktar (EUR)',
    campaignSelect: 'Destek Fonu Seçin',
    paymentMethod: 'Ödeme Yöntemi',
    creditCard: 'Kredi Kartı',
    sepaTransfer: 'Banka Havalesi (SEPA)',

    documentsBadge: 'Resmi Belgeler',
    documentsMainTitle: 'Tüzük, Raporlar ve İdari Evraklar',
    documentsSubtitle: 'Şeffaflık ilkemiz doğrultusunda dernek tüzüğümüz, yıllık faaliyet bilançolarımız ve resmi başvuru formları.',
    downloadDoc: 'Belgeyi İndir',

    galleryBadge: 'Galeri',
    galleryMainTitle: 'Fotoğraf ve Video Arşivi',
    gallerySubtitle: 'Derneğimizin düzenlediği şenlikler, konferanslar, dil kursları ve kültürel etkinliklerden kareler.',
    allMedia: 'Tüm Medya',
    photos: 'Fotoğraflar',
    videos: 'Videolar',

    contactBadge: 'İletişim',
    contactMainTitle: 'Bizimle İletişime Geçin',
    contactSubtitle: 'Sorularınız, üyelik başvurularınız veya kültürel önerileriniz için derneğimizle iletişime geçebilirsiniz.',
    mainAddress: 'Merkez Adres',
    phoneWhatsapp: 'Telefon & WhatsApp',
    startWhatsappChat: 'WhatsApp Sohbet Başlat',
    emailAddresses: 'E-Posta Adresleri',
    sendMessageTitle: 'Bizimle İletişime Geçin',
    fullNameLabel: 'Adınız Soyadınız',
    emailLabel: 'E-Posta Adresiniz',
    subjectLabel: 'Mijar / Konu',
    messageLabel: 'Mesajınız',
    sendBtn: 'Mesajı Gönder',
    msgSuccessTitle: 'Mesajınız Gönderildi!',
    msgSuccessDesc: 'En kısa sürede tarafınıza dönüş yapılacaktır.',

    liveBadge: 'CANLI YAYINDA',
    liveTitle: 'Kürt Dil Haftası Özel Semineri & Dengbêj Dinletisi',
    liveSub: 'YouTube, Facebook ve Zoom üzerinden yayınlanan canlı dernek seminerlerimiz.',
    chatRoomTitle: 'Canlı Sohbet Odası',
    typeMessage: 'Mesajınızı yazın...',

    memberPortal: 'Dernek Üye Paneli',
    profileDetails: 'Profil Bilgilerim',
    personalInfo: 'Kişisel Bilgiler',
    phoneNumber: 'Telefon Numarası',
    address: 'Adres',
    city: 'Şehir',
    country: 'Ülke',
    saveChanges: 'Değişiklikleri Kaydet',
    duesPayment: 'Aidat Ödemesi',
    duesHistory: 'Aidat Geçmişi',
    totalDonationsCount: 'Toplam Katkınız',
    guestUser: 'Misafir Kullanıcı',
    guestSubtitle: 'Kültür topluluğumuza katılın',

    // Navigation & Actions
    goBack: 'Geri',
    goForward: 'İleri',

    corporate: 'Kurumsal',
    quickAccess: 'Hızlı Erişim',
    footerAboutDesc: 'Kürt kültürünü, dilini ve geleneklerini korumak, yaşatmak ve gelecek kuşaklara aktarmak amacıyla çalışan sivil toplum kuruluşu.',
    statuteAndBalance: 'Tüzüğümüz & Bilanço',
    allRightsReserved: 'Tüm hakları saklıdır.',
    privacyPolicy: 'Gizlilik Politikası',
    cookiePolicy: 'Çerez Tercihleri',
    gdprNotice: 'KVKK / GDPR Aydınlatma',
    adminLogin: 'Yönetim Paneli',
  },
};
